var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm-dialog-component',{attrs:{"display":_vm.display,"title":_vm.title,"body":_vm.body}},[_c('button-component',{attrs:{"msg":"OK","width":"100px","height":"50px"},on:{"click":_vm.onClickOk}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }